import React from 'react';
import styles from './TableGroup.module.scss';

interface Props {
  children?: React.ReactNode;
  header?: React.ReactNode;
  className?: string;
  visible?: boolean;
}

const TableGroup = ({children, header, className, visible = true}: Props): React.ReactElement => (
  <>
    {
      visible &&
        <div className={className}>
          {
            header && <div className={styles.header}>{header}</div>
          }
          {children}
        </div>
    }
  </>
);

export default TableGroup;
